export type CommunicationsQueryKeyType = 'preview' | 'expiring' | 'communications' | 'messages';

/**
 * Query keys for communications, shared by both the generated-client module and the
 * deprecated legacy module so a single `useInvalidateCommunicationsCache` invalidates both.
 */
class CommunicationsQueryKeys {
  private prefix = 'communications';

  all() {
    return [this.prefix];
  }

  getCommunication(id: string) {
    return [this.prefix, id];
  }

  previewSlotDocument(
    communicationId?: string,
    formalityId?: string,
    slotId?: string,
    documentId?: string,
  ) {
    return [this.prefix, 'previewSlotDocument', communicationId, formalityId, slotId, documentId];
  }

  getCommunications(type: CommunicationsQueryKeyType, params?: object) {
    return [this.prefix, type, params].filter(Boolean);
  }

  searchCommunications(params?: object) {
    return [this.prefix, 'search', params].filter(Boolean);
  }

  getStructuredCommunicationTemplates() {
    return [this.prefix, 'structuredCommunicationTemplates'];
  }

  getStructuredCommunicationMessages(type: CommunicationsQueryKeyType, params?: object) {
    return [this.prefix, 'structuredCommunicationMessages', type, params].filter(Boolean);
  }
}

export default CommunicationsQueryKeys;
